export default __webpack_public_path__ + "static/hi-seas-5f4d4b28311b60ebff754fa27f09f27f.jpeg";